/** Local capture types for the Procurement Products Allergens/Ingredients/Nutritional Info tabs.
 * These are UI-only for now (no backend persistence exists yet on MarketItem). */

export enum ProductAllergenStatus {
  Contains = 'Contains',
  MayContain = 'MayContain',
  FreeFrom = 'FreeFrom',
}

export interface ProductAllergenEntry {
  allergenId: number;
  status: ProductAllergenStatus;
}

export interface ProductIngredient {
  id: number;
  name: string;
  percentage?: number;
  sortOrder: number;
}

